import React, {Component} from 'react'
import JobTable from "./table/JobTable"
import {Link} from "react-router-dom"
import {Icon, Pagination} from "antd"
import ListingJobFilter from "./ListingJobFilter"
import queryString from "query-string"
import {listLabelUpload} from "../../../services/api/labelApi"

class ListJobPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            message: '',
            listJob: [],
            page: 1,
            total: 0,
            limit: 50,
            filters: {
                status: '',
                shipping_carrier: '',
            }
        }
    }

    componentDidMount() {
        this._fetchListingJob()
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, () => {
            this._fetchListingJob()
        })
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, () => {
            this._fetchListingJob()
        })
    }

    _handleChangeSelect = (name, value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                [name]: value
            },
            page: 1
        }, () => {
            this._fetchListingJob()
        })
    }

    _fetchListingJob = async () => {
        this.setState({
            loading: true,
            error: '',
            message: ''
        })
        const {limit, page, filters} = this.state
        const newFilter = {}

        if (filters.status !== '') {
            Object.assign(newFilter, {status: filters.status})
        }

        if (filters.shipping_carrier !== '') {
            Object.assign(newFilter, {shipping_carrier: filters.shipping_carrier})
        }

        if (filters.created_at !== undefined && filters.created_at.from !== '' && filters.created_at.to !== '') {
            Object.assign(newFilter, {
                'created_at[from]': filters.created_at.from,
                'created_at[to]': filters.created_at.to
            })
        }

        const payload = {
            ...newFilter,
            limit,
            page,
            sort: '-created_at'
        }

        const query = queryString.stringify(payload)

        const {'data': response} = await listLabelUpload(query)

        const {success, data, error, message} = response

        if (!success) {
            return this.setState({
                loading: false,
                error: error
            })
        }

        this.setState({
            loading: false,
            message: message,
            listJob: data.uploadTasks,
            total: data.totalTasks
        })
    }

    render() {
        const {listJob, loading, error, page, total, limit, filters} = this.state

        return (
            <div className="ListJobPage">
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mb-3'>
                            <Link to={'/labels'}><Icon type="double-left" className='mr-2'/>Quay lại Labels</Link>
                        </div>

                        <div className="mb-3">
                            <h3>Danh sách upload label</h3>
                        </div>

                        <ListingJobFilter
                            filters={filters}
                            onChangeSelect={this._handleChangeSelect}
                        />

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                {
                                    error && (<div className="text-danger mb-2">{error}</div>)
                                }
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={
                                    (sum, range) => sum > 0 &&
                                        <div>
                                            Hiển
                                            thị <strong>{range[0]}</strong> đến <strong>{range[1]}</strong> của <strong>{total}</strong> files
                                            upload
                                        </div>
                                }
                                showQuickJumper
                                onChange={this._handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>

                        <JobTable
                            loading={loading}
                            limit={limit}
                            page={page}
                            listJob={listJob}
                            getListingJob={this._fetchListingJob}
                        />

                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            onChange={this._handlePageChange}
                            className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={this._handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ListJobPage
